import React from 'react'
import BannerMainImageSection from '../../../bannerMainImageSection'
import BannerBrandImageSection from '../../../bannerBrandImageSection'
import { Link } from 'react-router-dom'
import * as E from '../homeElements'
import { Row, Col } from 'react-bootstrap'
import { IProposalAcceptedWithoutNextStepsStageProps } from '../stages/interfaces/IProposalAcceptedWithoutNextStepsStageProps'

//This should be renamed to All completed or something similar
const ProposalAcceptedWithoutNextStepsStage = (
  props: IProposalAcceptedWithoutNextStepsStageProps
) => {
  const { firstName, settlementLink, proposalLink, digitalSettlement } = props

  return (
    <>
      <BannerMainImageSection>
        <E.WhiteHeading>OLY NOVATED LEASE</E.WhiteHeading>
        <h1>Congratulations {firstName}!</h1>
      </BannerMainImageSection>

      <BannerBrandImageSection id="maincontent">
        <E.ContainerBlock>
          <E.BannerButtonLinkParent>
            <Col sm={7}>
              <Row>
                <div id="proposalacceptedalldonestage.content">
                  You're all done! Now that the financier has finalised your
                  lease, there are no additional steps to complete.
                  <br />
                  Once you receive confirmation of settlement, don't forget to
                  download the Oly app to your mobile which will help you
                  keep track of things moving forward!
                </div>
              </Row>
            </Col>
            <E.BannerButtonLinkChild>
              {digitalSettlement && (
                <>
                  <Link to={settlementLink} tabIndex={-1}>
                    <E.BannerPrimaryButton id="proposalacceptedalldonestage.gotosettlements">
                      View paperwork
                    </E.BannerPrimaryButton>
                  </Link>

                  <br />
                  <br />
                </>
              )}
              <Link to={proposalLink} tabIndex={-1}>
                <E.BannerPrimaryButton
                  id="proposalacceptedalldonestage.viewproposal"
                  invertColor
                >
                  View my proposal again
                </E.BannerPrimaryButton>
              </Link>
            </E.BannerButtonLinkChild>
          </E.BannerButtonLinkParent>
        </E.ContainerBlock>
      </BannerBrandImageSection>
    </>
  )
}

export default ProposalAcceptedWithoutNextStepsStage
